import { Link } from "react-router-dom";
import { MessageCircle, Phone, MapPin, Lock } from "lucide-react";
import { STORE, waLink } from "@/lib/store";

export const Footer = () => (
  <footer className="mt-24 border-t border-neutral-200 bg-neutral-50 text-neutral-600">
    <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3">
      <div>
        <div className="mb-3 flex items-center gap-2">
          <img src="/iphix-logo.png" alt="iPhix Scafati" className="h-9 w-auto" />
        </div>
        <p className="max-w-xs text-sm text-neutral-500">Vendita e riparazione di smartphone, tablet e dispositivi elettronici a {STORE.city}.</p>
        <p className="mt-4 text-sm font-semibold text-neutral-500">iPhix 2.0</p>
        <p className="text-xs text-neutral-400">Powered by iPhix Scafati</p>
      </div>

      <div className="space-y-2 text-sm">
        <p className="mb-2 font-mono text-xs uppercase tracking-widest text-neutral-400">Menu</p>
        <Link to="/riparazioni" className="block hover:text-black">Riparazioni</Link>
        <Link to="/contatti" className="block hover:text-black">Contatti</Link>
        <Link to="/stato-ordine" className="block hover:text-black">Stato ordine</Link>
      </div>

      <div className="space-y-2 text-sm">
        <p className="mb-2 font-mono text-xs uppercase tracking-widest text-neutral-400">Contatti</p>
        {STORE.address && <p className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {STORE.address}</p>}
        {STORE.phone && <a href={`tel:${STORE.phone}`} className="flex items-center gap-2 hover:text-black"><Phone className="h-4 w-4" /> {STORE.phone}</a>}
        <a href={waLink("Ciao iPhix!")} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#128C4A] hover:text-[#25D366]"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
      </div>
    </div>

    <div className="border-t border-neutral-200">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 text-xs text-neutral-400 sm:px-6">
        <span>© {new Date().getFullYear()} iPhix Scafati</span>
        <Link data-testid="footer-login-link" to="/login" className="inline-flex items-center gap-1 hover:text-black"><Lock className="h-3 w-3" /> Area riservata</Link>
      </div>
    </div>
  </footer>
);
